
import { Box, Dialog, Grid, makeStyles, 
} from '@material-ui/core';
import ReelsBuilder from '../../pages/creator/reelsBuilder';

const useStyles = makeStyles(() => ({
  dialog: {
    borderRadius: '24px!important'
  },
  description: {
    color: '#697683',
    fontSize: 14,
    fontFamily: 'roboto-regular'
  },
  btn: {
    width: 80,
    height: 43,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 16,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  }
}));

function AddNewReelModel({open, onClose, selected, onRemove}: any) {
  
  
  const classes = useStyles();
  const selected_session :any[] = []
  selected && selected.map((session: any)=>{
    
    if(selected_session.indexOf(session.session_id) == -1)
      selected_session.push(session.session_id);
      
  });
  
  return (
    <Dialog
      fullWidth={true}
      fullScreen 
      onClose={onClose}
      open={open}
      className={classes.dialog}
    >
      <div >
        <Box m={4} pl={1} pr={1}>

          <Grid container>
            <Grid item md={12}>
              {/* {(step === "Schedule") && */}
                <ReelsBuilder selected={selected} onCloseReelModel={onClose} onRemove={(item:any)=>onRemove(item)} />
              {/* } */}
            </Grid>
          </Grid>
        </Box>
      </div>
    </Dialog>
  );
}

export default AddNewReelModel;
